var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-home"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/LOGO.svg"),"alt":""}})]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{attrs:{"to":"/my-nft"}},[_vm._v("My NFT")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }